import { render, staticRenderFns } from "./workStandardDetailStep.vue?vue&type=template&id=24d60170"
import script from "./workStandardDetailStep.vue?vue&type=script&lang=js"
export * from "./workStandardDetailStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24d60170')) {
      api.createRecord('24d60170', component.options)
    } else {
      api.reload('24d60170', component.options)
    }
    module.hot.accept("./workStandardDetailStep.vue?vue&type=template&id=24d60170", function () {
      api.rerender('24d60170', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mdm/sws/workStandardDetailStep.vue"
export default component.exports